import OptimizedLink from "../../Atoms/OptimizedLink";
import { useState } from "react";
import { MdStarBorder as MenuStarIcon } from "../../Atoms/AppIcons";
import DestinationPicker, {
  DestinationPickerLocation,
} from "./DestinationPicker";
import styles from "./Header.module.scss";

type CountryPickerProps = {
  locations: DestinationPickerLocation[];
  loading?: boolean;
};
export function CountryPicker({ locations, loading }: CountryPickerProps) {
  const [visibleSubMenu, setVisibleSubMenu] = useState<string | null>(null);

  const handleMouseEnter = (country: string) => setVisibleSubMenu(country);
  const handleMouseLeave = () => setVisibleSubMenu(null);

  return (
    <nav
      title="Search by city navigation"
      className={styles.AppHeaderCityPicker}
    >
      <ul>
        <li
          className={styles.SubMenuParent}
          onMouseEnter={() => handleMouseEnter("japan")}
          onMouseLeave={handleMouseLeave}
        >
          <OptimizedLink
            href={`/tours-japan?ref=nav`}
            className={styles.AppHeaderButton}
            onClick={handleMouseLeave}
            prefetchMode="disable"
          >
            <MenuStarIcon size={18} />
            <span> Japan</span>
          </OptimizedLink>
          <div
            style={
              visibleSubMenu === "japan"
                ? { display: "block" }
                : { display: "none" }
            }
          >
            <div className={styles.SubMenuArrow}></div>
            <DestinationPicker
              locations={locations}
              loading={loading}
              countryId={"a032f3f0-81a8-41ac-bf04-f46e3be952a5"}
              countryName="Japan"
              countrySlug="japan"
              onCityPick={handleMouseLeave}
            />
          </div>
        </li>

        <li
          className={styles.SubMenuParent}
          onMouseEnter={() => handleMouseEnter("thailand")}
          onMouseLeave={handleMouseLeave}
        >
          <OptimizedLink
            href={`/tours-thailand?ref=nav`}
            className={styles.AppHeaderButton}
            onClick={handleMouseLeave}
            prefetchMode="disable"
          >
            <MenuStarIcon size={18} />
            <span> Thailand</span>
          </OptimizedLink>
          <div
            style={
              visibleSubMenu === "thailand"
                ? { display: "block" }
                : { display: "none" }
            }
          >
            <div className={styles.SubMenuArrow}></div>
            <DestinationPicker
              locations={locations}
              loading={loading}
              countryId={"d6ab9244-a663-43b3-b5ac-92064879d22b"}
              countryName="Thailand"
              countrySlug="thailand"
              onCityPick={handleMouseLeave}
            />
          </div>
        </li>
      </ul>
    </nav>
  );
}
